import React from "react";
import { FormattedMessage } from "react-intl";

export default function Language(key) {
	return <FormattedMessage id={key} defaultMessage="{error}" values={{ error: <span style={{ color: "red" }}>{key}</span> }} />;
}
